// extracted by mini-css-extract-plugin
module.exports = {"desktop_wrapper":"_4f720283bf--desktop_wrapper--pEcwH","mobile_wrapper":"_4f720283bf--mobile_wrapper--PnEJC"};